import React from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

type Props = {
  type?: 'solid' | 'dashed'
}

const DashedGrid = styled.div`
  width: ${cssTheme.layout.spacing.s100};
  height: ${cssTheme.layout.spacing.s100};
  border-radius: ${cssTheme.layout.radius.sm};
  background-color: ${cssTheme.colors.border.neutral.secondary};
`

const Separator = styled.div`
  flex: 1;
  width: 1px;
  border-radius: ${cssTheme.layout.radius.md};
  border: 1px solid ${cssTheme.colors.border.neutral.secondary};
`

export const TimelineConnector = ({type = 'solid'}: Props) => {
  if (type === 'solid') return <Separator />
  if (type === 'dashed')
    return (
      <>
        <DashedGrid />
        <DashedGrid />
        <DashedGrid />
        <DashedGrid />
      </>
    )
  return null
}
